<app-update-banner />

<router-outlet />
<app-notification-modal />